
import { Formik, Form } from "formik";
import { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { OK } from "../../../constants/statusCode";
import { getDocuments } from "../../../features/user-document/documentListingSlice";
import { getSingleLabel, resetGetSingleLabelSlice } from "../../../features/user-document/getSingleLabelSlice";
import { labelListing } from "../../../features/user-document/label-listing";
import { updateLabel } from "../../../features/user-document/updateLabelSlice";
import labelValidations from "../../../validations/label/labelValidations";
import Select from "react-select";
import Button from "../../form-components/Button";
import Fields from "../../form-components/Fields";
import NestedSelect from "../NestedSelect";
import { useDispatch, useSelector } from "react-redux";
/* import { useRef } from "react"; */
// import { documentLableAdd } from "../../../features/user-document/document-label";
// import { showSuccess } from "../../../utils/messageHelper";
/* import DropdownTreeSelect from "react-dropdown-tree-select"; */

const EditLabelModal = ({
    isOpen,
    toggle,
    labelID,
    setLabelId,
    selectedLabel,
    selectedCheckbox,
    setSelectedLabel,
    setSelectedCheckbox,
    perPage,
    currentPage,
    setSubCategories,
    setCurrentModal,
    currentModal
}) => {
    let dispatch = useDispatch();
    let projectData = JSON.parse(localStorage.getItem("_user"));

    const {
        singleLabel = null,
        labelListingData = null,
    } = useSelector((state) => ({
        singleLabel: state?.singleLabelSlice?.responseData?.label,
        labelListingData: state?.labelListingSlice?.responseData?.label
    }))

    useEffect(() => {
        if (labelID) {
            dispatch(getSingleLabel(labelID))
        }
    }, [])
    /* const dropdownRef = useRef(null); */
    function renameProperties(obj) {
        // Make a copy of the current object
        const newObj = { ...obj };
        if (labelID !== newObj.uuid) {


            // Rename properties of the current object
            newObj.label = newObj.name;
            newObj.value = newObj.uuid;
            delete newObj.name;
            delete newObj.uuid;

            // Check for SubLabel properties
            if (newObj.SubLabel) {
                // Rename the SubLabel property
                newObj.children = newObj.SubLabel;

                // Recursively rename properties of the sub-labels
                newObj.children = newObj.children.map((subLabel) => {
                    return renameProperties(subLabel);
                });

                // Delete the original SubLabel property
                delete newObj.SubLabel;
            }
        }

        return newObj;
    }

    // Make a copy of the top-level objects and rename their properties
    let labelArray =
        labelListingData.length > 0
            ? labelListingData?.map((obj) => {
                return renameProperties(obj);
            })
            : [];


    /*  let selectedDropValue = {}; */
    /* const onDropdownChange = (currentNode, selectedNodes) => {
        selectedDropValue.selected = selectedNodes;
    };
    const onAction = (node, action) => {
        console.log("onAction::", action, node);
    };
    const onNodeToggle = (currentNode) => {
        console.log("onNodeToggle::", currentNode);
    }; */
    /* const nestedLabelOptions = labelListingData?.length > 0 && labelListingData.map((listData, index) => {
        let listingObj = { label: listData.name, value: listData?.uuid };
        return listingObj;
    }) */

    const languageOptions = [{
        label: 'English',
        value: 'English'
    }
    ];

    const labelSubmit = async (values) => {
        if (labelID) {
            let newObj = {};
            /* let selectedId = []; */
            /* (selectedDropValue?.selected !== undefined) && selectedDropValue?.selected.forEach((data) => selectedId.push(data.value)); */
            newObj.name = values?.label;
            /* newObj.parent_uuid = values?.nested_checked === true ?  singleLabel?.uuid :  singleLabel?.ParentSubLabel?.uuid; */
            /* newObj.parent_uuid = values?.nested_checked === true && selectedId.length > 0 ? selectedId.toString() : singleLabel?.ParentSubLabel?.uuid;; */
            /* newObj.uuid =  singleLabel?.uuid; */
            newObj.parent_uuid = values?.nested_checked === true ? values?.nested_label : singleLabel?.ParentSubLabel?.uuid;

            if (values?.nested_checked === true) {
                newObj.project_uuid = projectData?.projects[0]?.uuid;
                const { payload } = await dispatch(updateLabel({ id: labelID, body: newObj }));
                if (payload.status === OK) {
                    // setCurrentModal('');
                    toggle();
                    await dispatch(labelListing(projectData?.projects[0]?.uuid));
                    setSubCategories("Documents");
                    setLabelId('')
                    dispatch(
                        getDocuments({
                            perPage: perPage,
                            page: currentPage,
                            project_uuid: projectData?.projects[0]?.uuid,
                        })
                    );
                    dispatch(resetGetSingleLabelSlice())
                }
            } else {
                const { payload } = await dispatch(updateLabel({ id: labelID, body: newObj }));
                if (payload.status === OK) {
                    setSubCategories("Documents");
                    setCurrentModal('');
                    toggle();
                    dispatch(
                        getDocuments({
                            perPage: perPage,
                            page: currentPage,
                            project_uuid: projectData?.projects[0]?.uuid,
                        }));
                    dispatch(resetGetSingleLabelSlice())
                    setLabelId('');
                    dispatch(labelListing(projectData?.projects[0]?.uuid));
                }
            }
        }
        /* else {
            let newObj = {};
            if(values?.nested_checked && values?.nested_label){
                newObj.name = values?.label;
                newObj.parent_uuid = values?.nested_label?.value;
                newObj.project_uuid = projectData?.projects[0]?.uuid;
            } else {
                newObj.project_uuid = projectData?.projects[0]?.uuid;
                newObj.name = values?.label;
            }
           const { payload } = await dispatch(documentLableAdd(newObj));
           if(payload.status === 201){
            await dispatch(labelListing(projectData?.projects[0]?.uuid));
            showSuccess('Label Added successfully!');
            toggle();
           }
        } */
    }

    return (
        <>
            {singleLabel !== null &&
                <Modal
                    className="add-document-popup"
                    show={isOpen}
                    onHide={toggle}
                    // modalTransition={{ timeout: 2000 }}
                    dialogClassName="common-modal"
                >
                    <Modal.Header>
                        <h3 className="modal-title" id="Add_OrganizationLabel">{'Edit Label'}</h3>
                        {/* <button type='button' className='btn d-flex dlet-btn me-2'>
                                <img src="/static/media/trash.72657b09efa409e79727b60dd2c7bc45.svg" alt="" />
                            </button> */}
                        <Button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { toggle(); setLabelId(''); setSelectedLabel(''); setSelectedCheckbox(''); dispatch(resetGetSingleLabelSlice()) }}></Button>
                    </Modal.Header>
                    <>
                        <Formik
                            initialValues={{
                                label: singleLabel?.name || '',
                                language: 'english',
                                nested_label: singleLabel?.ParentSubLabel?.uuid || '',
                                nested_checked: singleLabel?.ParentSubLabel?.uuid ? true : false
                            }}
                            validationSchema={labelValidations}
                            onSubmit={labelSubmit}
                        >
                            {({
                                values,
                                handleChange,
                                handleBlur,
                                touched,
                                errors,
                                isSubmitting,
                                handleSubmit,
                                setFieldValue,
                            }) => (
                                <Form>
                                    <Modal.Body>
                                        <p className='mb-3'>New categories should be added in the default language. The default language is set to:</p>
                                        <div className="form-group">
                                            <div className="form-group">
                                                <Select
                                                    id="inputGroupSelect01"
                                                    name="language"
                                                    placeholder="Please select a language..."
                                                    value={{ label: 'Language: English', value: 'English' }}
                                                    isDisabled
                                                    onChange={value => setFieldValue("language", value?.value)}
                                                    options={languageOptions}
                                                    classNamePrefix="cmn-control"
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-group">
                                                <label className="form-label">Please enter a new label name:</label>
                                                <Fields
                                                    type="text"
                                                    placeholder="Enter new label"
                                                    touched={touched}
                                                    errors={errors}
                                                    onBlur={handleBlur}
                                                    name="label"
                                                    value={values.label}
                                                    className="form-control"
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="form-check">
                                                {/*               <Fields
                          type="checkbox"
                          id="flexCheckChecked"
                          touched={touched}
                          errors={errors}
                          onBlur={handleBlur}
                          name="remember"
                          value={values.remember}
                          className="form-check-input"
                          onChange={handleChange}
                        /> */}
                                                <Fields type="checkbox" touched={touched} className="form-check-input" name="nested_checked" onChange={handleChange} checked={values?.nested_checked} />
                                                <label className="form-check-label">Nested label under</label>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <div className="form-group">
                                                <div className="nested-select">
                                                    <select onChange={handleChange} name="nested_label" value={values?.nested_label}>
                                                        {values?.nested_checked === true ? (<option>Please select a parent...</option>) : (<option>{"\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}</option>)}
                                                        {labelArray.map((data, index) => {
                                                            return (
                                                                <>
                                                                    <NestedSelect key={index} child={data} level={0} />
                                                                </>
                                                            )
                                                        })}
                                                    </select>
                                                </div>
                                                {/* <DropdownTreeSelect
                                                    ref={dropdownRef}
                                                    data={labelArray?.length > 0 ? labelArray : []}
                                                    onChange={onDropdownChange}
                                                    onAction={onAction}
                                                    onNodeToggle={onNodeToggle}
                                                    mode="multiSelect"
                                                    texts={{ placeholder: values?.nested_checked === true ? 'Please select a parent...' : '      ' }}
                                                    disabled={(labelArray?.length > 0 && values?.nested_checked === true) ? false : true}
                                                /> */}
                                            </div>
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button type="submit" disabled={isSubmitting} className="btn btn-primary-md" onClick={handleSubmit}>Update</Button>
                                    </Modal.Footer>
                                </Form>
                            )}
                        </Formik>
                    </>
                    {/* <Modal.Footer>
                    <Button type="button" disabled={isLoading} className="btn btn-primary-md" onClick={() => createNewDoc()}>Save</Button>
                </Modal.Footer> */}
                </Modal>
            }
        </>
    );
}

export default EditLabelModal;